export const TypeAngles = {
    "Tipo B": 0,
    "Tipo A": 52,
    "Tipo A1": 120,
    "Tipo C": 50,
    "Tipo D": 115,
}